import request from 'tools/request'
import Auth from 'tools/AuthService'
export const SET_USER_LIST = 'SET_USER_LIST'
export const SET_USER_ById = 'SET_USER_ById'
export const SET_FORM_INITIALVALUE = 'SET_FORM_INITIALVALUE'
export const SET_USER = 'SET_USER'
export const SET_PROFILE_FORM_CONFIG = 'SET_PROFILE_FORM_CONFIG'

export const dispatchUsersList = (data, headers) => ({
    type: SET_USER_LIST,
    data,
    headers
})

export const dispatchUserById = (data) => ({
    type: SET_USER_ById,
    data
})

export const dispatchFormConfig = (data) => ({
    type: SET_FORM_INITIALVALUE,
    data
})

export const getUsersList = (filters = {}, pagination = {}, clientId = Auth.selectedClient, clientUuid) => async (dispatch) => {
    const query = {
        ...filters
    }
    const url = clientUuid ? `clients/${clientUuid}/users` : 'users'
    const res = await request(
        url,
        'GET',
        null,
        true,
        {
            'x-client-Id': clientId,
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 10
        },
        query
    )
    dispatch(dispatchUsersList(res.response, res.headers))
    return res
}

export const getUserById = (clientId) => async (dispatch) => {
    const res = await request(`users/${clientId}`, 'GET')
    dispatch(dispatchUserById(res))
    return res
}

export const createUser = (formData, clientId = Auth.selectedClient) => async () => {
    const payLoad = {
        ...formData,
        userRoles: formData?.roles?.map(role => role.systemName)
    }
    const res = await request(
        'users',
        'POST',
        payLoad,
        true,
        {
            'x-client-Id': clientId,
        }
    )
    return res
}

export const updateCreditMemoApprover = (userId, approver, clientId = Auth.selectedClient) => async () => {
    return await request(`users/${userId}/credit-memo-approver`, 'PUT', { approver }, false, { 'x-client-Id': clientId })
}

export const updateUser = (formData, clientId = Auth.selectedClient) => async () => {
    const payLoad = {
        ...formData,
        userRoles: formData?.roles?.map(role => role.systemName)
    }
    delete payLoad.roles
    const res = await request(
        `users/${payLoad.userId}`,
        'PATCH',
        payLoad,
        true,
        {
            'x-client-Id': clientId,
        }
    )
    return res
}

export const updateProfile = (payLoad) => async () => {
    const res = await request(`user/update-me`, 'PATCH', payLoad)
    return res
}

export const updatePassword = (payLoad) => async () => {
    const res = await request(`user/change-password`, 'POST', payLoad)
    return res
}

// How the current approver signs credit memos: { mark: TYPED|DRAWN, stamp: PLAIN|STAMP|SEAL, drawnImage, signerName, configured }
export const getMySignature = () => request('users/me/credit-memo-signature', 'GET', null, false, {}, undefined, false, true)

export const saveMySignature = (payload) => request('users/me/credit-memo-signature', 'PUT', payload)

export const resetMySignature = () => request('users/me/credit-memo-signature', 'DELETE')

/**
 * Grants or revokes a user's exemption from its client's two-factor requirement (ROX-1878).
 * Deliberately its own endpoint: carried by the generic user patch it would also travel on
 * PATCH /users/me, where a user would be exempting itself.
 */
export const updateTwoFactorExemption = (userId, exempt, clientId = Auth.selectedClient) => async () => {
    const res = await request(
        `users/${userId}/two-factor-exemption`,
        'PATCH',
        { exempt },
        false,
        {
            'x-client-Id': clientId,
        }
    )
    return res
}

export const toggleUser = (userId, active) => async () => {
    const endpoint = active ? 'disable' : 'enable'
    const res = await request(`users/${userId}/${endpoint}`, 'POST')
    return res
}

export const setDashboardFilters = (filters) => {
    const res =  request('users/dashboard-filters', "PATCH", filters )
    return res
}

export const getDashboardFilters = () => {
    const res =  request('users/dashboard-filters', "GET" )
    return res
}

export const updateDemoMode  = (demoModeFlag) => {
    const res = request('users/demo-mode', "PATCH", {demoModeFlag: demoModeFlag})
    return res
}

export const callBackDocusign = (code) => {
    const res =  request('docusign/oauth2callback?code=' + code, "GET", null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const getDocusignConfig = () => {
    const res =  request('docusign/config', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const getTaxrockConfig = () => {
    const res =  request('taxrock/config', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const disconnectTaxrock = () => {
    const res =  request('taxrock/config', 'DELETE', null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const deleteDocusignConfig = () => {
    const res =  request('docusign/config', 'DELETE', null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const getAllTemplates = () => {
    const res =  request('docusign/template', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const getAllAccount = () => {
    const res =  request('docusign/account', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const getAllTemplatesByAccount = (accountId) => {
    const res =  request('docusign/account/' + accountId + '/template', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}
export const updateDocusignConfig = (payLoad) => {
    const res =  request('docusign/config', 'PUT', payLoad, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

/**
 * Docusign lookups scoped to an explicit client, for the Rox Admin client profile:
 * these endpoints resolve the client from the x-client-Id header (numeric id), while the
 * admin template endpoints take the client uuid in the path. Silent, since a non
 * superuser cannot read another client's Docusign account and the caller degrades gracefully.
 */
export const getDocusignConfigByClientId = (clientId) => {
    return request('docusign/config', 'GET', null, true, { 'x-client-Id': clientId }, null, false, true)
}

export const getDocusignAccountsByClientId = (clientId) => {
    return request('docusign/account', 'GET', null, true, { 'x-client-Id': clientId }, null, false, true)
}

export const getDocusignTemplatesByClientId = (clientId, accountId) => {
    return request(`docusign/account/${accountId}/template`, 'GET', null, true, { 'x-client-Id': clientId }, null, false, true)
}

export const startGmailOauth = (clientId) => {
        const res = request('gmail-auth/start/'+clientId,'GET', null, true, { 'x-client-Id': Auth.selectedClient },  null);
        return res;
}

export const getMarketplaceCriteria = () => {
    const res =  request('marketplace-criteria', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const createMarketplaceCriteria = (payLoad) => {
    const res =  request('marketplace-criteria', 'POST', payLoad, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}

export const updateMarketplaceCriteria = (payLoad) => {
    const res =  request('marketplace-criteria', 'PUT', payLoad, true, { 'x-client-Id': Auth.selectedClient }, null)
    return res
}
export const updateFeatureFlags = (payload) => async () => {
    const res = await request(
        `marketplace-config`,
        'POST',
        payload,
        true,
        {
            'x-client-Id': Auth.selectedClient,
        }
    )
    return res
}